import { Static, Type } from '@sinclair/typebox'

/**
 * One change a turn made to the flow, read from the persisted flow.
 * Typed by kind so the chat draws it with an icon: a step name, a field
 * label or a value is never wrapped in a translated sentence.
 */
export const FlowChangeLine = Type.Union([
    Type.Object({ kind: Type.Literal('step_added'), step: Type.String() }),
    Type.Object({ kind: Type.Literal('step_removed'), step: Type.String() }),
    /** Removed and re-created elsewhere in the same turn: same piece operation, same name */
    Type.Object({ kind: Type.Literal('step_moved'), step: Type.String() }),
    Type.Object({ kind: Type.Literal('trigger_set'), step: Type.String() }),
    Type.Object({ kind: Type.Literal('step_renamed'), before: Type.String(), after: Type.String() }),
    /** A loop, a router, or a step whose field labels are unknown: never a prop key */
    Type.Object({ kind: Type.Literal('step_changed'), step: Type.String() }),
    Type.Object({ kind: Type.Literal('fields_updated'), step: Type.String(), fields: Type.Array(Type.String()) }),
    /** Values a list field lost, named because the loss is the one nobody notices */
    Type.Object({
        kind: Type.Literal('values_removed'),
        step: Type.String(),
        field: Type.String(),
        values: Type.Array(Type.String()),
    }),
])
export type FlowChangeLine = Static<typeof FlowChangeLine>

/**
 * What a turn that wrote to the flow did to it: the changes, or — when it
 * tried and nothing came of it — that nothing changed, whatever the
 * assistant's own answer claims
 */
export const TurnChanges = Type.Union([
    Type.Object({
        kind: Type.Literal('changed'),
        lines: Type.Array(FlowChangeLine),
        /** The flow is published: the change needs a republish to take effect */
        republishNeeded: Type.Boolean(),
    }),
    Type.Object({ kind: Type.Literal('nothing_changed') }),
])
export type TurnChanges = Static<typeof TurnChanges>
